import React, { FC, memo, useCallback } from 'react';

const apiGooglePlacesKey = 'AIzaSyDRlXkY2RLj_iPBmaZwyKAS0HjNtsPx6LQ';

interface Props {
  address: string;
}

const GMaps: FC<Props> = ({ address }) => {
  const convertAddressToGMap = useCallback((address) => address.replace(' ', '+'), [address]);

  return (
    <iframe
      height={200}
      src={`https://www.google.com/maps/embed/v1/place?key=${apiGooglePlacesKey}&q=${convertAddressToGMap(address)}`}
    />
  );
};

export default memo(GMaps);
